import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { StoreInventory } from './model/StoreInventory';

export const useStoreSDDInventory = (
    productId: string | undefined,
    quantity: number | undefined,
    latitude: number | undefined,
    longitude: number | undefined,
    enabled = true,
): UseQueryResult<StoreInventory> =>
    useBffGet(
        '/stores/inventory/same-day-delivery',
        [
            { productId: productId ?? '' },
            { quantity: quantity ?? '' },
            { latitude: latitude ?? '' },
            { longitude: longitude ?? '' },
        ],
        [
            BffQueryKey.STORE_SDD_INVENTORY,
            productId ?? '',
            String(quantity ?? ''),
            String(latitude ?? ''),
            String(longitude ?? ''),
        ],
        {
            enabled: enabled && !!productId && !!quantity && !!latitude && !!longitude,
            keepPreviousData: true,
            headers: {
                'Cache-Control': 'no-store',
            },
        },
    );
